import { useAuth0 } from "@auth0/auth0-react";
import Avatar from "@material-ui/core/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { default as FinancialSetting } from "Lib/API/FinanceSetting/FinanceSetting";
import { ReactComponent as BlankLinkIcon } from "assets/icons/blankLinkIcon.svg";
import Button from "components/button/Button";
import useTemplateReplacement from "hook/useTemplateReplacement ";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
import deceasedPhoto from "../../../assets/icons/deceasedPhoto.png";
import {
  setAddLogo,
  setOpenRecipients,
  setSelectedDeceased,
} from "../../commonSlice";
import "./index.scss";

const DeceasedLetter = ({ openLetterModal, setOpenLetterModal, setCheck }) => {
  const dispatch = useDispatch();
  const selectedDeceased = useSelector(
    (state) => state.CommonStates.selectedDeceased
  );
  const [loading, setLoading] = useState(false);
  const [templateContent, setTemplateContent] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [addLogo, setAddLogoState] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  // const [content, setContent] = useState("")

  const orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );
  const logoImg = orgData?.logoImg;

  let selectedMourners = [];

  const mourners = selectedDeceased?.map((dec) => {
    return dec?.mourners_list?.forEach((item) => {
      selectedMourners.push({
        ...item,
        name: dec?.name,
        "hebrew name of Death": dec?.hebrew_name_of_Death,
        "hebrew date of death": dec?.hebrew_date_of_death,
        "mother name": dec?.mother_name,
        "date of death": dec?.date_of_death,
        gender: dec?.gender,
        "about the deceased": dec?.about_the_deceased,
        cemetery: dec?.cemetery,
        "plaque number": dec?.plaque_number,
      });
      return item;
    });
  });

  

  const { content } = useTemplateReplacement(templateContent, getAccessTokenSilently, "deceased");

  const getTemplateByType = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    try {
      const response = await FinancialSetting.getTemplateByType(
        token,
        "yehrzeit"
      );
      setTemplateContent(response?.result?.htmlContent);

      setAddLogoState(response?.result?.addLogo);
      dispatch(setAddLogo(response?.result?.addLogo));
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTemplateByType();
  }, []);

 

  const mournerWithEmail = selectedMourners
    ?.filter((item) => item?.member_id?.email_address || item?.email)


  const mournerAvarars = mournerWithEmail
    ?.slice(0, 3)
    ?.map((item) => {
      return (
        <Avatar
          alt={item?.member_id?.first_name}
          src={item?.member_id?.profile_img}
          className="mourner__avatar"
        >
          {item?.member_id?.first_name &&
            item?.member_id?.last_name &&
            (item?.member_id?.first_name[0] + item?.member_id?.last_name[0])
              .toString()
              .toUpperCase()}
        </Avatar>
      );
    });

  const otherMourners = mournerWithEmail?.slice(3)?.length >
    0 && (
    <Avatar alt="other mourners" src="" className="mourner__avatar">
      +{mournerWithEmail?.slice(3)?.length}
    </Avatar>
  );



  return (
    <div className="deceased_modal_container">
      <div className="deceased__photo">
        <img src={deceasedPhoto} alt="deceased" />
      </div>
      <div className="letter__content">
        <div className="letter__header">
          <div className="letter__content__title">
            <h2>Send Yahrzeit Letter</h2>
            <span className="avatars__container">
              Send to:{mournerAvarars}
              {otherMourners}
            </span>
          </div>
          <div className="letter__btns">
            <Button
              onClick={() => {
                setOpenLetterModal(false);
                dispatch(setSelectedDeceased([]));
                setCheck([]);
              }}
              variant="primary-outline"
              size="md"
              style={{ minWidth: "100px" }}
            >
              Cancel
            </Button>
            <Button
               onClick={() => {
                setOpenLetterModal(false);
                dispatch(setOpenRecipients(true));
              }}
              variant="primary"
              size="md"
              style={{ minWidth: "100px" }}
            >
              Send
            </Button>
          </div>
        </div>
        <div className="letter__body">
          <div className="letter__body__header">
            <div style={{ width: "100px", height: "100px" }}>
              {addLogo ? (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={logoImg}
                  alt="logo"
                />
              ) : null}
            </div>
            <Link
              className="Link__go_to_temlate d-flex"
              to="/communication?tab=Templates"
              onClick={() => {
                setOpenLetterModal(false);
                localStorage.setItem("openYahTemplate", true);
              }}
            >
              <BlankLinkIcon className="mr-2" /> Go to template
            </Link>
          </div>
          <div className="letter__body__content">
            {loading ? (
              <div className="w-100 text-center">
                <CircularProgress />
              </div>
            ) : (
              <p dangerouslySetInnerHTML={{ __html: content }} />
            )}
            {/* <p>
              Dear <span>{'{{fname}} {{Family Name}}'},</span>
              Just wanted to remind you of consectetur adipiscing elit ut
              aliquam, <span>{'{{fname of deceased}}'}</span> purus sit amet
              luctus venenatis, lectus magna <span>{'{{death date}}'}</span>{' '}
              porttitor consectetur adipiscing elit ut aliquam, purus sit amet
              luctus venenatis, lectus magna fringilla urna.
              <br />
              <br />
              Thank you,
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeceasedLetter;
